import {
  put,
  putResolve,
  take,
  takeLatest,
  all,
} from 'redux-saga/effects';
import _ from 'lodash';
import { getAdminId, isAuthenticated } from 'app/ducks/authentication/selectors';
import { sagaActions } from 'app/ducks/global/actions';
import { GlobalActionTypes as types } from 'app/ducks/global/types';
import { AdminsActionTypes } from 'app/ducks/admins/types';
import { OrganisationsActionTypes } from 'app/ducks/organisations/types';
import { CompetitionsActionTypes } from 'app/ducks/competitions/types';
import { getAdmin } from 'app/ducks/admins/actions';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { selectLastCompetition } from 'app/ducks/competitions/actions';
import history from 'app/routes/history';
// import { getOrganisation } from "ducks/organisations/actions";
// import { getAllPeople } from "ducks/people/actions";
// import { getAllOrganisationTags } from "ducks/organisationTags/actions";
// import { getAllGroups } from "ducks/groups/actions";

function* globalLoadSaga(): any {
  const authenticated = yield isAuthenticated();
  if (!authenticated) {
    history.push('/login');
  }
  const adminId: string = yield getAdminId();
  yield put(sagaActions.globalLoadPending());
  yield put(loadingStart());
  yield putResolve(yield getAdmin(adminId));

  // const organisationId = yield select((state) => state.organisations.currentOrganisationId);

  if (yield isAuthenticated() && !_.isEmpty(adminId)) {
    yield take(AdminsActionTypes.GET_ADMIN_SUCCESS);
    yield take([OrganisationsActionTypes.GET_ORGANISATION_SUCCESS]);
    yield putResolve(selectLastCompetition());
    yield take(CompetitionsActionTypes.SELECT_LAST_COMPETITION_FINISHED);
  }

  yield put(sagaActions.globalLoadFinished());
  yield put(loadingFinish());
}

/* ********************************* SAGA WATCHERS ********************************* */

function* globalLoadSagaWatcher(): any {
  yield takeLatest(types.GLOBAL_LOAD_REQUESTED, globalLoadSaga);
}

export default function* root(): any {
  yield all([globalLoadSagaWatcher()]);
}
